import * as types from '../mutation-types';
import HubAPI from '../../api/hub';

export const state = {
  projects: [],
  workspaces: [],
  uiFlags: {
    isFetchingProjects: false,
    isFetchingWorkspaces: false,
  },
};

export const getters = {
  getProjects: $state => $state.projects,
  getWorkspaces: $state => $state.workspaces,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetchProjects: async ({ commit }) => {
    commit(types.default.SET_HUB_PROJECTS_FETCHING_STATUS, true);
    try {
      const { data } = await HubAPI.getClaudiaProjects();
      commit(types.default.SET_HUB_PROJECTS, data);
    } catch (error) {
      // silently fail
    } finally {
      commit(types.default.SET_HUB_PROJECTS_FETCHING_STATUS, false);
    }
  },
  fetchWorkspaces: async ({ commit }) => {
    commit(types.default.SET_HUB_WORKSPACES_FETCHING_STATUS, true);
    try {
      const { data } = await HubAPI.getEddieWorkspaces();
      commit(types.default.SET_HUB_WORKSPACES, data);
    } catch (error) {
      // silently fail
    } finally {
      commit(types.default.SET_HUB_WORKSPACES_FETCHING_STATUS, false);
    }
  },
};

export const mutations = {
  [types.default.SET_HUB_PROJECTS_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingProjects = status;
  },
  [types.default.SET_HUB_WORKSPACES_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingWorkspaces = status;
  },
  [types.default.SET_HUB_PROJECTS]($state, data) {
    $state.projects = data;
  },
  [types.default.SET_HUB_WORKSPACES]($state, data) {
    $state.workspaces = data;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
